__turbopack_context__.v({
  "bar": "AccountSkeletons-module__WGUJUG__bar",
  "settings": "AccountSkeletons-module__WGUJUG__settings",
  "settingsButton": "AccountSkeletons-module__WGUJUG__settingsButton",
  "settingsField": "AccountSkeletons-module__WGUJUG__settingsField",
  "settingsGroup": "AccountSkeletons-module__WGUJUG__settingsGroup",
  "settingsIntro": "AccountSkeletons-module__WGUJUG__settingsIntro",
  "settingsLabel": "AccountSkeletons-module__WGUJUG__settingsLabel",
  "shimmer": "AccountSkeletons-module__WGUJUG__shimmer",
  "tripCard": "AccountSkeletons-module__WGUJUG__tripCard",
});
